<template>
  <HeaderTrade/> 
  <!-- Container Start { -->
  <div id="container">
    <!-- Contents Start { -->
    <div id="contents">

      <!-- content start -->
      <div class="contents-area">

        <!-- 글쓰기 start -->
        <div class="bbs-write">
          <div class="bbs-write-tb">

            <ul class="write-category-list" @click="onSelectCategory">
              <li
                v-for="(item, index) in categorylist"
                :key=index
              >
                <a href="javascript:;" class="item" :id="`${item.CODE}`">{{item.NAME}}</a>
              </li>
            </ul>

            <div class="mb-2">
              <label for="inputSubject" class="visually-hidden">제목</label>
              <input v-model="rTitle" type="text" class="form-control" id="inputSubject" placeholder="제목을 입력하여 주세요." maxlength="50">
            </div>

            <label for="inputContents" class="visually-hidden">textarea</label>
            <!-- <QuillEditor class="form-control" id="inputContents" style="font-size: 16px; border-radius: 2px; height:200px"  rows="20"  theme="snow"  toolbar="full" ref="rContent" placeholder="내용을 입력해주세요." /> -->
            <!-- <textarea class="form-control" id="inputContents" rows="20"></textarea> -->
            <QuillEditor 
              class="form-control"
              id="inputContents"
              style="font-size: 16px; border-radius: 2px; height:180px"
              rows="20"
              theme="snow"
              ref="rContent"
              :toolbar="[
                [{ 'size': ['small', false, 'large', 'huge'] }],
                ['bold', 'underline',{ 'color': [] }, { 'background': [] }],
                [],
                [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'align': [] }],
                ['link', 'image'],
                ['video'],
              ]"
              :modules="modules"
              @textChange="txtChange"
               />
            <div class="text-danger fs-12 mt-1">&#8251; 주의 : 게시물은 텍스트, 이미지를 포함해 10MB 이하입니다. 동영상파일은 40MB이하입니다.</div>

            <form class="visually-hidden">
              <input type="file" name="videoUpload" id="videoUpload"  @input="onFlieInput" accept="video/mp4, video/ogg, video/wmv"/>
            </form>        

            <div class="bbs-write-btn">
              <button class="btn btn-outline-gray" type="button" @click="$router.go(-1)">취소</button>
              <button class="btn btn-danger" type="button" @click="onSaved">{{ !$route.params.id == '' ? '수정' : '등록'}}</button>
            </div>
          </div>
        </div>
        <!-- //글쓰기 end -->

        <!-- 등록 안내 start -->
        <div class="section community-write-info mb-0">
          <CommunityPolicy/>
        </div>        

      </div>
      <!-- //content end -->  

    </div>
    <!-- } Contents End -->

  </div>
  <!-- } Container End -->
 <Footer/>

</template>

<script>

import HeaderTrade from '@/components/HeaderTrade.vue';
import CommunityPolicy from '@/components/terms/CommunityPolicy.vue';
import axios from '@/axios';
import { useRoute, useRouter }from 'vue-router'
import Footer from '@/components/Footer.vue';
import { useApicall } from '@/composables/commonFn';
import { onMounted, ref,  getCurrentInstance, onUnmounted, computed } from 'vue';
import { useStore } from 'vuex';
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
// import '@vueup/vue-quill/dist/vue-quill.bubble.css'
//import Config from '../../public/config.js';
import MagicUrl from 'quill-magic-url'

export default {
components:{  
    HeaderTrade, 
    Footer,
   QuillEditor,
   CommunityPolicy,
},    
setup(){
    
  //  const trace = getCurrentInstance().appContext.config.globalProperties.$log;
   const emitter = getCurrentInstance().appContext.config.globalProperties.emitter;
   const route = useRoute();
   const router = useRouter();
   const  categorylist =  ref([]);
   const categoryCode = ref('');
   const {apiCall_g, apiCall_pt} = useApicall();
   const store = useStore();
   const rTitle = ref(null);
   const rSelectBox = ref('null');
   const rContent = ref(null);
   store.commit('trade/CHANGE_CURRENT_PAGE_ID', 'navi_1');
  store.commit('common/CHANGE_CURRENT_PAGE', 'Community_write');
   const boardItem = ref(null);
   const page_store = computed(() => store.state.common.currentPage);
  // trace("route.params.item:^^^^", route.params)
   const openGraphTags = ref('');

   var  mode = 1;
   
   //mode = 1:쓰기 2:수정
    const getCategorylist = async()=>{    
    const res = await apiCall_g(`/board/categorylist?type=community`);
    var result = res.dataList;
    if(!result) result = [];
      return result
    }


    // const onTempSaved = ()=>{
    //    trace("onTempSaved")
    //     trace(rSelectBox.value.value)
    // }


    const onSaved = ()=>{
      // trace("onSaved") 
      var contentString = rContent.value.getHTML().replace(/<[^>]*>?/g, '');
      if(!categoryCode.value) {
        emitter.emit('EVENT_ALERT',{title:"알림", body:"카테고리를 선택하여 주세요"});
        return;
      }        
      if(!rTitle.value)
      {
          emitter.emit('EVENT_ALERT',{title:"알림", body:"제목을 입력해주세요"});
        return;
      }
      if( contentString == '')
      {
          emitter.emit('EVENT_ALERT',{title:"알림", body:"내용을 입력해주세요"});
        return;
      }

      if(rTitle.value.length <= 2 || contentString.length <= 2) {
        emitter.emit('EVENT_ALERT',{title:"알림", body:"제목/내용은 2글자 이상 작성하여 주세요."});
        return;
      }

      saveBoard()
    }  

    const saveBoard = async ()=>{           
         var params ={};
         var res = null
        if(mode == 1 ){
            params = {
                "categoryCode": categoryCode.value,
                "subject": rTitle.value,
                "contents": rContent.value.getHTML()   
            } 
            res = await apiCall_pt(`board/write`, params);

        }else  if(mode == 2){
            params = {
                "idx": boardItem.value.IDX,
                "categoryCode": categoryCode.value,
                "subject": rTitle.value,
                "contents": rContent.value.getHTML()   
            } 
            res = await apiCall_pt(`board/modify`, params, 'PUT');
        }

         if(res){
            emitter.emit('EVENT_ALERT',{title:"알림", body:"게시글을 저장했습니다."});
             router.push({
                name:'Community'
            })
         }
    }

    const  getModifyBoardItem = async ()=>{
      const res = await apiCall_g(`board/view?idx=${route.params.id}`);
      return res.data; 
    }

    onMounted(async ()=>{
      emitter.emit('EVENT_CHECK_LOGIN');
      addVideoUploadButton();
      rContent.value.getQuill().setSelection(0);      
      categorylist.value = await getCategorylist();          
      // trace("categorylist:~~~~~~~", categorylist.value)
      
      if( route.params.id ) {
        mode = 2;
        boardItem.value = await getModifyBoardItem();
        rTitle.value = boardItem.value.SUBJECT;
        categoryCode.value = boardItem.value.CATEGORY_CODE;
        rContent.value.setHTML(boardItem.value.CONTENTS);
        document.getElementById(categoryCode.value).classList.add('active');
        openGraphTags.value = 2;
        // rSelectBox.value.disabled = true;
      } else {
        mode = 1;
        categoryCode.value = categorylist.value[0].CODE;
        document.querySelector('.write-category-list').classList.add('write');
        // rSelectBox.value.disabled = true;
      }
    })


    const onSelectCategory = (e) => {
      var btn = e.target;
      var categoryLists = document.querySelectorAll('.write-category-list .item');
      var writeClassRemove = document.querySelector('.write-category-list.write');

      if(writeClassRemove) {
        writeClassRemove.classList.remove('write');
      }
        
      categoryLists.forEach((list) => {
        list.classList.remove('active');
      });
      btn.classList.add('active');
      categoryCode.value = btn.id;
      // console.log('onSelectCategory  ========>', categoryCode.value);
    }      

    const txtChange = (delta) => {  
      var opsArry = delta.delta.ops;
      // console.log('txtChange---:', delta)

      if(opsArry.some(ops => ops.attributes)) {
        var attrArry = [];
        var urlArry = [];

        var editorLinkTags = document.querySelectorAll('.ql-editor > p > a');
        editorLinkTags.forEach(linkTag => {
          linkTag.parentNode.classList.add('og-link');
        });

        var ogLinkTags = document.querySelectorAll('.og-link');
        if(ogLinkTags.length !== 0) {
          ogLinkTags.forEach(ogLink => {
            if(ogLink.nextSibling !== null) {
              if(ogLink.nextSibling.firstChild.tagName == 'BR') {
                ogLink.nextSibling.remove();
              }
            }
            ogLink.classList.remove('og-link');
          });
        } else {
          return false;
        }

        for(const item of opsArry) {
          attrArry.push(item.attributes);
        }

        urlArry = attrArry.filter((element) => element !== undefined);

        if( mode == 1 ) {
          if(urlArry.length > 1) {
            emitter.emit('EVENT_ALERT',{title:"알림", body:"붙여넣기 URL은 1개씩 입력하여 주십시오."});
            return false;
          } else {
            getOpenGraph(urlArry[0].link);
          }
        } else if( mode == 2 ) {
          if( openGraphTags.value == 1 ) {
            if(urlArry.length > 1) {
              emitter.emit('EVENT_ALERT',{title:"알림", body:"붙여넣기 URL은 1개씩 입력하여 주십시오."});
              return false;
            } else {
              getOpenGraph(urlArry[0].link);
            }
          }
          openGraphTags.value = 1;
        }

      } else {
        return false;
      }

    }

    const getOpenGraph = async(_ogUrl) => {
      // console.log('getOpenGraph111111',_ogUrl);

      try {
        const res = await axios.post(`index/getHtmlText`, { 'url' : _ogUrl }, {
          headers: { token: sessionStorage.getItem('token') }
        });
        let json =  res.data;
        var getHtml = null;
        // var getUrl = null;

        // console.log('getOpenGraph222222222:', json);
        if (json.returnCode == 1) {
          // getUrl = json.resultMap.url;
          getHtml = document.createElement('div');
          getHtml.innerHTML = json.resultMap.responseData;
          setOpenGraph(getHtml);
        } else {
          console.log("error", json.message);
          emitter.emit('EVENT_ALERT',{title:"알림", body:"해당사이트의 오픈그래프가 존재하지 않습니다.\n다시 입력하여 주세요."});
        }
      } catch(error) {     
        console.log('error2', error);
        emitter.emit('EVENT_ALERT',{title:"알림", body:"해당사이트의 오픈그래프가 존재하지 않습니다.\n다시 입력하여 주세요."});
        return false;
      }
    }

    const setOpenGraph = (_html) => {     
      var ogTit = _html.querySelector('meta[property="og:title"]').content;
      var ogDesc = _html.querySelector('meta[property="og:description"]').content;
      var ogImg = _html.querySelector('meta[property="og:image"]').content;

      var quill = rContent.value.getQuill();
      var delta = quill.clipboard.convert();

      if( ogTit !== null || ogDesc !== null || ogImg !== null ) {
        quill.insertText(delta, ogTit, 'user');
        quill.insertText(delta, ogDesc, 'user');
        quill.insertEmbed(delta, 'image', ogImg, 'api');
        quill.setSelection(quill.getLength());
      //   // quill.update('user');

        var getEditorDescTags = document.querySelectorAll('.ql-editor > p > img');
        getEditorDescTags.forEach(descTag => {
          descTag.parentNode.previousSibling.classList.add('og-desc');
        });

        var getEditorTitleTags = document.querySelectorAll('.og-desc');
        getEditorTitleTags.forEach(titTag => {
          titTag.previousSibling.classList.add('og-tit');
          titTag.nextSibling.firstChild.classList.add('og-img');
        });

      } else {
        quill.insertText(delta, '해당 사이트의 오픈그래프가 존재하지 않습니다.');
        // quill.update('user');
      }
    }    

    onUnmounted(()=> {
      if(page_store.value !== 'Community') {
        store.commit('common/CHANGE_CUMMUNITY_CURRENT_PAGE', 1);
      }
    })

   var limitSize = 40 * 1024 * 1024;

    const onFlieInput = (e) => {
      var frm = new FormData();
      frm.append("upfile",  e.target.files[0]);

      // console.log(11111, e.target.files[0], e.target.files[0].size/1024, limitSize)
      if(e.target.files[0]) {
        if(/\.(mp4|ogg|wmv)$/i.test(e.target.files[0].name)) {
          callVideoUploadApi(frm);
        } else {
          emitter.emit('EVENT_ALERT',{title:"알림", body:"동영상은 (mp4, ogg, wmv)만 가능합니다."});
          e.target.value = '';
          return;
        }

        if(e.target.files[0].size > limitSize)
        {
          emitter.emit('EVENT_ALERT',{title:"알림", body:`동영상은 용량은 ${ limitSize / (1024 * 1024) }MB 이하만 가능합니다.`});
          return;
        }
      } 

      e.target.value = '';
      // console.log(22222, e.target.files[0])
    }

    const callVideoUploadApi = (frm) =>{
         var token = sessionStorage.getItem('token');      
        //  console.log("", Config.URL.apiGroundUrl + 'board/uploadvideo')
         axios.post('board/uploadvideo', frm, {
          headers: {
              'Content-Type': 'multipart/form-data',
              'token': token,
          }
         })
         .then((response) => {
            // 응답 처리
            const range = rContent.value.getQuill().getSelection();
            // const newRange = addVideoRange !== null ? addVideoRange.index : 0;
            rContent.value.getQuill().insertEmbed(range.index, 'video', response.data.resultMap.data.linkUrl);
            rContent.value.getQuill().setSelection(range.index + 1);
         })
         .catch((error) => {
            // emitter.emit('EVENT_ALERT',{title:"알림", body:"동영상은 (mp4, ogg, wmv)만 가능합니다."});
            console.log("callVideoUploadApi: error ->", error )
         // 예외 처리
         })
    }

    const addVideoUploadButton = () => {
      var toolbar = document.querySelector('.ql-toolbar');
      var videoUploadBtn = document.createElement("span");

      videoUploadBtn.classList.add('ql-inner-btn');
      videoUploadBtn.innerHTML = `<button type="button" class="btn ql-video-upload">upload</button>`
      toolbar.append(videoUploadBtn);

      document.querySelector('.ql-video-upload').addEventListener('click', () => {
        document.getElementById('videoUpload').click();
      });
    }    

    return{
      categorylist,
      onSaved,
      rTitle,
      rContent,
      rSelectBox,
      boardItem,
      page_store,
      onSelectCategory,
      categoryCode,
      onFlieInput,
      modules : {
        name: 'magicUrl',
        module:MagicUrl,
      },
      txtChange,
      openGraphTags,  
    }
}
}
</script>

<style>

</style>

